/**
 * Communication Skill Area
 * Lessons focused on voice, quality control, content strategy, and communication systems
 */

export { voiceTuneUp } from './voice-tune-up';
export { promptSprint } from './prompt-sprint';
export { newsletterRemix } from './newsletter-remix';
export { spotHallucinations } from './spot-hallucinations';
export { qualityControl } from './quality-control';
export { aiBriefing } from './ai-briefing';
export { contentIntelligence } from './content-intelligence';
export { strategicDirection } from './strategic-direction';
export { communicationSystems } from './communication-systems';

import { voiceTuneUp } from './voice-tune-up';
import { promptSprint } from './prompt-sprint';
import { newsletterRemix } from './newsletter-remix';
import { spotHallucinations } from './spot-hallucinations';
import { qualityControl } from './quality-control';
import { aiBriefing } from './ai-briefing';
import { contentIntelligence } from './content-intelligence';
import { strategicDirection } from './strategic-direction';
import { communicationSystems } from './communication-systems';
import type { LessonDefinition } from '../types';

export const communicationLessons: LessonDefinition[] = [
  voiceTuneUp,
  promptSprint,
  newsletterRemix,
  spotHallucinations,
  qualityControl,
  aiBriefing,
  contentIntelligence,
  strategicDirection,
  communicationSystems,
];
